import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import type { AuthUser } from 'api/AuthApi';
import { authApi } from 'api/AuthApi';
import type { RootState } from 'store/store';

type AuthState = {
  user: AuthUser | null;
  isSpecialPrice: boolean;
  accessToken: string | null;
};

const slice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    isSpecialPrice: false,
    accessToken: null
  } as AuthState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    setIsSpecialPrice(state, action: PayloadAction<boolean>) {
      state.isSpecialPrice = action.payload;
    },
    logout(state) {
      state.accessToken = null;
      state.user = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        isAnyOf(
          authApi.endpoints.login.matchFulfilled,
          authApi.endpoints.loginGoogle.matchFulfilled,
          authApi.endpoints.loginFacebook.matchFulfilled
        ),
        (state, { payload }) => {
          state.accessToken = payload;
        }
      )
      .addMatcher(authApi.endpoints.me.matchFulfilled, (state, { payload }) => {
        state.user = payload;
      })
      .addMatcher(authApi.endpoints.logout.matchFulfilled, (state, { payload }) => {
        state.user = null;
        state.accessToken = null;
      });
  }
});

export const { setAccessToken, logout, setIsSpecialPrice } = slice.actions;
export default slice.reducer;

export const selectAuthUser = (state: RootState) => state.auth.user;
export const selectAuthToken = (state: RootState) => state.auth.accessToken;
